import { RegistrationPreview } from '@lotngo/shared';
import { apiClient } from './client';

export async function getRegistrationPreview(code: string, phone: string) {
  const res = await apiClient.get<{ data: RegistrationPreview }>(
    `/auth/registration-preview?code=${encodeURIComponent(code)}&phone=${encodeURIComponent(phone)}`,
  );
  return { data: res.data.data };
}

export async function forgotPassword(emailOrPhone: string) {
  const res = await apiClient.post<{ data: { message: string } }>(
    '/auth/forgot-password',
    { email_or_phone: emailOrPhone },
  );
  return res.data.data;
}

export async function resetPassword(email: string, token: string, password: string) {
  const res = await apiClient.post<{ data: { message: string } }>(
    '/auth/reset-password',
    { email, token, password },
  );
  return res.data.data;
}
